import { type MovieCoreResponse, toMovieTag } from 'src/models/apis/movie/movieResponse';
import type { TagMovieUpdateResponse } from 'src/models/tagMovie';

export interface TagMovieUpdateResponseRaw extends MovieCoreResponse {
  g1id: number;
}

export const toTagMovieUpdate = (response: TagMovieUpdateResponseRaw): TagMovieUpdateResponse => ({
  deviceId: response.device_id,
  duration: response.duration,
  id: response.id,
  location: { lat: response.lat, lon: response.lon },
  movieGroupId: response.movie_group_id,
  startTs: response.start_ts,
  tags: response.tags.map(toMovieTag),
  g1id: response.g1id,
});
